import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import * as logger from "../../../logger";
import { deleteInvoice } from '../../../store/actions/tripActionCreator';
import { connect } from "react-redux";
import { trackDwebEvent } from '../../analytics';
import { getMilliDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils';

const useStyles = makeStyles((theme) => ({
    cancelV1: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    deleteV1: {
        color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    },
    divV1: {
        fontWeight: 300, fontSize: 16
    }
}));

const DeleteInvoiceDialog = ({ open, trip, invoiceId, onConfirm, onClose, dispatchDeleteInvoice }) => {

    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleDialogClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const onDelete = () => {
        const singleInvoiceData = trip && trip.singleInvoiceInfo ? trip.singleInvoiceInfo : {}
        dispatchDeleteInvoice(invoiceId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Delete Invoice Dialog Dweb", "Delete Invoice Successfull");
                    setDialogOpen(false);
                    onConfirm();
                    trackDwebEvent('Dweb Invoice deleted', {
                        party_name: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.customerName ? singleInvoiceData.invoiceDetails.customerName : "",
                        party_id: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.customerId ? singleInvoiceData.invoiceDetails.customerId : "",
                        count_of_trips: singleInvoiceData && singleInvoiceData.trips ? singleInvoiceData.trips.length : 0,
                        total_invoice_amount: singleInvoiceData && singleInvoiceData.amounts && singleInvoiceData.amounts.total ? singleInvoiceData.amounts.total : "",
                        invoice_number: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.invoiceNumber ? singleInvoiceData.invoiceDetails.invoiceNumber : "",
                        invoice_date: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.invoiceDate ? getMilliDatePickerDateInStringDDMMMYYYY(singleInvoiceData.invoiceDetails.invoiceDate) : "",
                        due_days: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.dueIn ? singleInvoiceData.invoiceDetails.dueIn : "",
                        invoice_id: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.id ? singleInvoiceData.invoiceDetails.id : "",
                        invoice_balance: singleInvoiceData && singleInvoiceData.amounts && singleInvoiceData.amounts.balance ? singleInvoiceData.amounts.balance : ""
                    })
                }
            },
            () => {
                logger.log("Delete Invoice Dialog Dweb", "Delete Invoice Failed");
            }
        )
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={dialogOpen} onClose={handleDialogClose}
            >
                <DialogContent>
                    <div className={classes.divV1}>Do you want to delete the Invoice ? </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>
                        <span className={classes.cancelV1}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onDelete}>
                        <span className={classes.deleteV1}>
                            DELETE
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchDeleteInvoice: (invoiceId, onSuccess, onError) => {
        dispatch(deleteInvoice(invoiceId, onSuccess, onError))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteInvoiceDialog);